import React, { useLayoutEffect } from 'react';
import { useEffect, useState, useRef, useContext } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography } from "@mui/material";
import PropTypes from 'prop-types';
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import DeleteIcon from '@mui/icons-material/Delete';
import { GridToolbarContainer, GridActionsCellItem, } from '@mui/x-data-grid';
import { randomId } from '@mui/x-data-grid-generator';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens, useHideMode } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import useAxiosPrivate from "../../hooks/useAxiosPrivate"
import saveConnectedAccounts from "../../components/managers/saveConnectedAccounts.js"
import ConfirmDialog from '../../components/ConfirmDialog';
import { useLocation, useNavigate } from 'react-router-dom';
import { SettingsBarContext } from '../../context/SettingsBarContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import handleError from '../../hooks/handleError';


function EditToolbar(props) {
    const { setConnAccts, setDisplayedConnAccounts } = props;

    const handleClick = () => {
        const id = randomId();
        const newRow = {
            id, name: '',
            checkpoint_blob: '{"transactions": 0, "net_worth": 0, "block": 0}',
            api_credentials: '{"client_id": "", "client_secret": "", "scope": ""}',
            crypto_wallet_info: '{"xpub": "", "name": "", "account_index": 0, "wallet": "", "receive_addresses": [], "change_addresses": [], "associated_app_account": "", "from_ledger": true},',
            actions: "INSERT"
        };
        setConnAccts((oldRows) => [...oldRows, newRow])
        setDisplayedConnAccounts((oldRows) => [...oldRows, newRow]);
    };

    return (
        <GridToolbarContainer>
            <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                ADD RECORD
            </Button>
        </GridToolbarContainer>
    );
}






EditToolbar.propTypes = {
    setDisplayedConnAccounts: PropTypes.func.isRequired,
};






const ConnectedAccounts = () => {

    useEffect(() => {
        document.title = 'Connected Accounts | Fretless Finance';
    }, []);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const hideTheme = useHideMode();
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const location = useLocation();
    var [Connected_Accounts, setConnAccts] = useState([]);
    var [DisplayedConnAccounts, setDisplayedConnAccounts] = useState([]);
    var [open, setOpen] = useState(false);
    var [deleteId, setDeleteId] = useState(0);
    var isMounted = false;
    const effectRan = useRef(false);
    const controller = new AbortController();
    var [saveConnAcctsError, setSaveConnAcctsErr] = useState('');
    var err = false;
    const errRef = useRef();
    const { isSettingsBarOpen, toggleSettingsBar } = useContext(SettingsBarContext);

    useEffect(() => {
        if (isSettingsBarOpen) {
            toggleSettingsBar();
        }
        return () => {
            effectRan.current = true;
        }
    }, [])

    function convertObjectsToStrings(array) {
        if (array?.length > 0) {
            array.forEach((obj, index) => {
                const newObj = {};
                for (const key in obj) {
                    if (typeof obj[key] === 'object' && obj[key] !== null) {
                        newObj[key] = JSON.stringify(obj[key]);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
                array[index] = newObj;
            });
        }
        return [...array]
    }


    useEffect(() => {
        if (effectRan.current === false) {

            let isMounted = true;
            const controller = new AbortController();

            const getConnAccounts = async () => {
                try {
                    var ConnAcctsResponse = await axiosPrivate.get('/Settings/get/connected-accounts', {
                        signal: controller.signal
                    });
                    isMounted && setConnAccts(convertObjectsToStrings(ConnAcctsResponse.data));
                    setDisplayedConnAccounts(convertObjectsToStrings(ConnAcctsResponse.data));

                } catch (err) {
                    if ((err.response?.status === 401) || (err.response?.status === 403)) {
                        navigate('/sign-in', { state: { from: location }, replace: true });
                    }
                    else {
                        handleError(err);
                    }
                }
            }

            getConnAccounts();
            effectRan.current = true;
        }
        return () => {
            isMounted = false;
            controller.abort();

        }


    }, [])

    function PasswordCellRenderer(props, width) {
        const [hideSensitiveInfo, setHideSensitiveInfo] = useState(true);

        if (props.value?.length > 0 || (typeof props.value === 'object' && props.value !== null)) {
            var password = props.value;
            const maskedPassword = '***************' ?? '';
            const displayPassword = hideSensitiveInfo ? maskedPassword : password;
            const boxDefault = {
                height: "1vh",
                width: 250,
                m: 1,
                display: "flex"

            }
            return <div width="250px">
                <Box display="flex"
                    alignItems="center"
                    justifyContent="flex-end"
                    sx={boxDefault}
                >
                    <Box style={{ justifyContent: 'flex-start' }}>{displayPassword}</Box>
                    {
                        hideSensitiveInfo ? (
                            <IconButton onClick={() => setHideSensitiveInfo(false)}>
                                <VisibilityIcon />
                            </IconButton>
                        ) : (
                            <IconButton onClick={() => setHideSensitiveInfo(true)}>
                                <VisibilityOffIcon />
                            </IconButton>
                        )}

                </Box >
            </div>
        }

    }


    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, actions: ((newRow.actions !== "INSERT" & newRow.actions !== "DELETE") ? "UPDATE" : newRow.actions) };
        setConnAccts(Connected_Accounts.map((row) => (row.id === updatedRow.id ? updatedRow : row)));
        setDisplayedConnAccounts(DisplayedConnAccounts.map((row) => ((row.id === updatedRow.id & updatedRow.actions !== "DELETE") ? updatedRow : row)));
        return updatedRow;
    };

    const deleteAccount = () => {
        const deletedRow = Connected_Accounts.filter((row) => row.id === deleteId)[0]
        deletedRow.actions = "DELETE"

        processRowUpdate(deletedRow)
        setDisplayedConnAccounts(DisplayedConnAccounts.filter((row) => row.id !== deleteId));
    };

    const saveChangesHandler = event => {
        try {
            err = saveConnectedAccounts(Connected_Accounts);
        } catch (err) {
            err = true;
            if (!err?.response) {
                setSaveConnAcctsErr('No Server Response');
            } else if (err.response?.status === 500) {
                setSaveConnAcctsErr('Backend Error, check your fields');
            } else if (err.response?.status === 401) {
                setSaveConnAcctsErr('Unauthorized')
            } else {
                setSaveConnAcctsErr('Error')
            }
        }

        if (!err) {
            var updatedArray = Connected_Accounts.filter((row) => row.actions !== "DELETE")
            updatedArray = updatedArray.map(row => ({ ...row, actions: null }));
            setConnAccts(updatedArray)
        }
        err = false;
    }


    const columns = [
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                return [
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        onClick={() => {
                            setDeleteId(id);
                            setOpen(true);
                        }}
                        color="inherit"
                    />,
                ];
            },
        },
        {
            field: "account",
            headerName: "Account",
            width: 150,
            type: "string",
            headerAlign: "center",
            align: "center",
            editable: true,
        },
        {
            field: "name",
            headerName: "Name",
            width: 200,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
        },
        {
            field: "website",
            headerName: "Website",
            width: 350,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
        },
        {
            field: "username",
            headerName: "Username",
            width: 300,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
            valueFormatter: (params) => hideTheme.mode === "show" ? params.value : '*'.repeat(9),
        },
        {
            field: "password",
            headerName: "Password",
            width: 300,
            type: "string",
            headerAlign: "center",
            editable: true,
            renderCell: (params) => <PasswordCellRenderer value={params.value} />,

        },
        {
            field: "checkpoint_blob",
            headerName: "Checkpoint",
            width: 450,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
        },
        {
            field: "api_credentials",
            headerName: "API Credentials",
            width: 400,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
            renderCell: (params) => <PasswordCellRenderer value={params.value} />,
            wrap: true,
        },
        {
            field: "crypto_wallet_info",
            headerName: "Crypto Wallet Info",
            width: 400,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
            renderCell: (params) => <PasswordCellRenderer value={params.value} />,
            wrap: true,
        },
        {
            field: "data",
            headerName: "Data",
            width: 400,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
            renderCell: (params) => <PasswordCellRenderer value={params.value} />,
            wrap: true,
        },


    ];

    return (
        <Box m="20px">
            <Header
                title="CONNECTED ACCOUNTS"
                titleSize="h2"
                subtitle="Added External Accounts"
                subtitleSize="h5"
            />
            < ToastContainer />

            <Box
                m="40px 0 0 0"
                height="67vh"
                sx={{
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                    },
                    "& .name-column--cell": {
                        color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[400],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[400],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                    },
                }}
            >
                <DataGrid
                    rows={DisplayedConnAccounts}
                    columns={columns}
                    CanUserAddRows="True"
                    CanUserDeleteRows="True"
                    processRowUpdate={processRowUpdate}
                    components={{ Toolbar: EditToolbar }}
                    componentsProps={{
                        toolbar: { Connected_Accounts: Connected_Accounts, setConnAccts, setDisplayedConnAccounts }
                    }}
                    experimentalFeatures={{ newEditingApi: true }}
                    options={{ customToolbar: () => { } }}
                />
                <ConfirmDialog
                    title="Delete Account"
                    message="Are you sure you want to delete this?"
                    confirmBtnText="DELETE"
                    open={open}
                    setOpen={setOpen}
                    onConfirm={deleteAccount}>
                </ConfirmDialog>
            </Box>
            <Box padding="1rem" align="right">
                <Button onClick={saveChangesHandler}
                    sx={{
                        backgroundColor: colors.greenAccent[500],
                        color: "#ffffff",
                        '&:hover': {
                            backgroundColor: colors.greenAccent[300],
                            color: "#ffffff",
                        },
                        fontSize: "14px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                    }}
                >
                    <SaveIcon sx={{ mr: "10px" }} />
                    Save Changes
                </Button>
            </Box>

        </Box>
    );
};

export default ConnectedAccounts;